module.exports = false;


//////////////////
// WEBPACK FOOTER
// /var/cache/omnibus/src/gitlab-rails/~/core-js/modules/_library.js
// module id = 9VD9
// module chunks = 1